import { ValueLanguage } from "../../assets/languages/langs";

/**
 * Returns a human-readable name from a string or a multi-language object.
 * If the input is a string, returns it directly. If it is an object, returns
 * the value for the specified language, or the first available translation.
 */
const getHumanReadableNameCellHelper = (
	str?: string | Record<string, string> | undefined | null,
	lang?: ValueLanguage,
): string => {
	if (!str) return "";
	if (typeof str === "string") return str;

	const byLang = lang ? str[lang] : undefined;
	if (byLang) return byLang;

	const firstAvailable = Object.values(str).find(
		(value) => typeof value === "string" && value.length > 0,
	);

	return firstAvailable || "";
};

export default getHumanReadableNameCellHelper;
